module.exports = __webpack_public_path__ + "static/media/icon_anunciate_alcance.00d7c539.svg";